import { IClientProfile } from "../../types/profile/IClientProfile";
import { ClientProfileUpdateRequest } from "../controllers/settings/clientProfileUpdateRequest";

export const convertClientProfileUpdateRequest = (
    profile: IClientProfile
): ClientProfileUpdateRequest => {
    if (!profile) return null;
    const request: ClientProfileUpdateRequest = {
        contactInfo: {
            clientUserId: profile.clientUserId,
            firstName: profile.firstName,
            lastName: profile.lastName,
            email: profile.email,
            phoneNumber: profile.phoneNumber,
        },
        settings: {
            isAgentActive: profile.isAgentActive,
        },
    };
    return request;
};
